export * from "./DoctorProfile";
export { default } from "./DoctorProfile.gql";
